// API
import { apiFetch } from '../../app/apiFetch';

/**
 * @function postMessage
 * Posts a chat message to the API
 *
 * @return {object} Message
 */
export function postMessage(sessionId: number, messageBody: string) {
    const endpoint = `/v1/chat/create`;
    const body = JSON.stringify({
        sess: sessionId,
        text: messageBody,
    });

    return apiFetch('POST', endpoint, body);
}
